export function getdata() {
	let obj = {
		
			headData: [
				{
					title: "",
					prop: "zzsxgm_1_x_1",
					custom: true,
					width: "200px"
				},
				{
					title:'',
					prop:'zzsxgm_1_x_2',
					width: "200px",
					custom: true,
				},
				{
					title:'',
					prop:'zzsxgm_1_x_3',
					width: "200px",
					custom: true,
				},
				{
					title:'',
					prop:'zzsxgm_1_x_4',
					width: "200px",
					custom: true,
				},
			],
			tableData: [
				{
					title:'应税行为（3%征收率）扣除额计算',
				},
				{
					title1:'期初余额',
					title2:'本期发生额',
					title3:'本期扣除额',
					title4:'期末余额',
				}
				,{
					value1:'1',
					value2:'2',
					value3:'3（3≤1＋2之和，且3≤5）',
					value4:'4＝1＋2－3',
				}
				,{
					disabledzzsxgm_1_x_1:false,
					disabledzzsxgm_1_x_2:false,
					disabledzzsxgm_1_x_3:false,
					disabledzzsxgm_1_x_4:false,
					zzsxgm_1_x_1: {
						cellCode:"zzsxgm_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_2: {
						cellCode:"zzsxgm_1_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_3: {
						cellCode:"zzsxgm_1_1_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_4: {
						cellCode:"zzsxgm_1_1_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title:'应税行为（3%征收率）计税销售额计算',
				},
				{
					title1:'全部含税收入（适用3%征收率',
					title2:'本期扣除额',
					title3:'含税销售额',
					title4:'不含税销售额',
				},{
					value1:'5',
					value2:'6=3',
					value3:'7＝5－6',
					value4:'8＝7÷1.03',
				},{
					disabledzzsxgm_1_x_1:false,
					disabledzzsxgm_1_x_2:false,
					disabledzzsxgm_1_x_3:false,
					disabledzzsxgm_1_x_4:false,
					zzsxgm_1_x_1: {
						cellCode:"zzsxgm_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_2: {
						cellCode:"zzsxgm_1_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_3: {
						cellCode:"zzsxgm_1_2_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_4: {
						cellCode:"zzsxgm_1_2_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应税行为（5%征收率）扣除额计算',
				},
				{
					title1:'期初余额',
					title2:'本期发生额',
					title3:'本期扣除额',
					title4:'期末余额',
				},{
					value1:'9',
					value2:'10',
					value3:'11（11≤9＋10之和，且11≤13）',
					value4:'12＝9＋10－11',
				},{
					disabledzzsxgm_1_x_1:false,
					disabledzzsxgm_1_x_2:false,
					disabledzzsxgm_1_x_3:false,
					disabledzzsxgm_1_x_4:false,
					zzsxgm_1_x_1: {
						cellCode:"zzsxgm_1_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_2: {
						cellCode:"zzsxgm_1_3_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_3: {
						cellCode:"zzsxgm_1_3_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_4: {
						cellCode:"zzsxgm_1_3_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应税行为（5%征收率）计税销售额计算',
				},
				{
					title1:'全部含税收入（适用5%征收率）',
					title2:'本期扣除额',
					title3:'含税销售额',
					title4:'不含税销售额',
				},{
					value1:'13',
					value2:'14=11',
					value3:'15＝13－14',
					value4:'16＝15÷1.05',
				},{
					disabledzzsxgm_1_x_1:false,
					disabledzzsxgm_1_x_2:false,
					disabledzzsxgm_1_x_3:false,
					disabledzzsxgm_1_x_4:false,
					zzsxgm_1_x_1: {
						cellCode:"zzsxgm_1_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_2: {
						cellCode:"zzsxgm_1_4_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_3: {
						cellCode:"zzsxgm_1_4_3",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_1_x_4: {
						cellCode:"zzsxgm_1_4_4",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
		
	}
	return obj
}
